module.exports = __webpack_public_path__ + "img/nft-doll.c24ac83e.png";